export default { panCardRegex: /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]$/, aadharregex: /[0-9]{12}$/ };
